"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var SelectSource = (function (_super) {
    __extends(SelectSource, _super);
    function SelectSource() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderSource = function (source) {
            var _a = _this.props, selected = _a.selected, selectSource = _a.selectSource;
            return (react_1.default.createElement("div", { key: source.title, className: (0, classnames_1.default)(["source", "".concat(source.cssClass, "-import"), { selected: source.internalName === selected }]), onClick: function () { return selectSource(source); } },
                react_1.default.createElement("div", { className: "icon-".concat(source.cssIcon, " icon") }),
                react_1.default.createElement("div", { className: "description" },
                    react_1.default.createElement("h4", { className: "title" }, source.title),
                    react_1.default.createElement("p", null, source.description))));
        };
        return _this;
    }
    SelectSource.prototype.render = function () {
        var _a = this.props, sources = _a.sources, goBackToThisStep = _a.goBackToThisStep, finished = _a.finished;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(["step", "select-source", { finished: finished }]) },
            finished && react_1.default.createElement("div", { className: "step-finished-badge icon-check" }),
            react_1.default.createElement("header", { className: "step-header" },
                react_1.default.createElement("div", { className: "icon-layers icon" }),
                react_1.default.createElement("div", { className: "text-content" },
                    react_1.default.createElement("h3", { className: "title" },
                        react_1.default.createElement("span", { className: "step-number" }, "1. "),
                        "Select Source"),
                    react_1.default.createElement("p", { className: "subtitle" }, "Choose a source to import data from."))),
            react_1.default.createElement("div", { className: "select-source" }, sources.map(this.renderSource)),
            finished && (react_1.default.createElement("div", { className: "back-step-hover-tile", onClick: goBackToThisStep },
                react_1.default.createElement("label", { className: "label" }, "Go Back")))));
    };
    SelectSource = __decorate([
        mobx_react_1.observer
    ], SelectSource);
    return SelectSource;
}(react_1.default.Component));
exports.default = SelectSource;
